import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { CircularProgressbarWithChildren, buildStyles } from 'react-circular-progressbar';
var DigitalEditStatus = function DigitalEditStatus(_ref) {
  var digitalEdit = _ref.digitalEdit;
  var iconStyle = {
    color: digitalEdit.color
  };
  if (digitalEdit.processing) {
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-circle-o-notch",
      spin: true
    });
  }
  return /*#__PURE__*/React.createElement(CircularProgressbarWithChildren, {
    value: 10,
    maxValue: 10,
    styles: buildStyles({
      pathColor: digitalEdit.color,
      textColor: digitalEdit.color
    })
  }, digitalEdit.failed ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-times",
    style: iconStyle
  }) : null, digitalEdit.processing ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-gears",
    style: iconStyle
  }) : null, digitalEdit.completed ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-check",
    style: iconStyle
  }) : null);
};
export default DigitalEditStatus;